import React from 'react'
import { detailed_features } from '../../constants'
import styles, { layout } from '../../style'
import Button from './Button'

const FeatureCard = ({ icon, title, content, index}) => (
  <div className={`flex flex-row p-6 rounded-[20px] ${index !== detailed_features.length - 1 ? "mb-6" : "mb-0"} feature-card`}>
    <div className='flex-1 flex flex-col ml-3'>
      <h4 className='font-poppins font-semibold text-black text-[18px] leading-[23px] mb-1'>
        {title}
      </h4>
      <p className='font-poppins font-normal text-dimWhite text-[16px] leading-[24px] mb-1'>
        {content}
      </p>
    </div>

  </div>
)

const FeatureBreakdown = () => {
  return (
    <section
      id="features"
      className={layout.section}
    >
      <div className={layout.sectionInfo}>
        <h2 className={styles.heading2}> WE WALK OUR TALK. <br className='sm:block hidden' />
          Access the best data available.
        </h2>
        <p className={`${styles.paragraph} max-w-[470px] mt-5`}>
        Five By Five is the first cloud-based managed service that combines
        the five major arbitrages to tip the "digital media buying" scales
        in your favor. Are you open to seeing how we do it?
        </p>
        <Button styles="mt-10"/>
      </div>

      <div className={`${layout.sectionImg} flex-col`}>
        {detailed_features.map((feature, index) => (
          <FeatureCard key={feature.id} {...feature} index={index}/>
        ))} 
      </div>


    </section>
  )
}

export default FeatureBreakdown